import { IContainerProps } from 'props';
import styled from 'styled-components';

export const Container = styled.div<IContainerProps>`
  width: 85%;
  max-width: 100rem;
  position: relative;
  border-radius: 15px;
  padding: 1.5rem;
  background: ${({ theme, color }) => theme.colors[color]};

  @media (max-width: 900px) {
    width: -webkit-fill-available;
    margin: 0 1.5rem;
  }

  @media (max-width: 320px) {
    margin: 0 0.5rem;
    padding: 0.5rem;
  }
`;
export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;

  .containerPicture {
    display: flex;
    justify-content: space-between;

    .icon {
      height: 2.2rem;
      display: flex;
      align-items: start;

      button {
        padding: 0;
      }
    }
    .contentPicture {
      padding: 1rem 0;
    }
  }

  .containerOrigin {
    display: flex;
    gap: 1rem;

    p {
      font-size: 1.7rem;
      font-weight: 600;
      padding: 0;
      color: ${({ theme }) => theme.colors.secondary};
    }

    .selectOrigin {
      display: flex;
    }
  }

  .containerContacts {
    .contentContacts {
      width: 100%;
      display: flex;
      padding: 0.5rem 0;
      align-items: baseline;
      gap: 1rem;

      .contact {
        width: 100%;
        max-width: 30rem;
        display: flex;
        gap: 1rem;
        align-items: baseline;

        p {
          color: ${({ theme }) => theme.colors.tertiary_500};
          font-size: 1.3rem;
          text-align: end;
          width: 6rem;
        }
      }

      .containerButton {
        display: flex;
        align-items: center;
        gap: 1rem;

        .removeContact {
          border-radius: 100%;
          font-size: 2rem;
          max-width: 2rem;
          min-width: 2rem;
          max-height: 1.5rem;
          min-height: 1.5rem;
        }

        .containerRemoveContact {
          max-width: 2rem;
          max-height: 1.5rem;
          min-height: 1.5rem;
        }

        .validade {
          border-radius: 2rem;
          padding: 0.2rem 1.2rem;
          color: ${({ theme }) => theme.colors.tertiary_500};
          border: 1px ${({ theme }) => theme.colors.tertiary_500} solid;
        }
        svg {
          fill: ${({ theme }) => theme.colors.tertiary_500};
        }
      }
    }

    .containerAddContact {
      display: flex;
      margin-top: 1rem;

      .addContact {
        display: flex;
        gap: 0.5rem;
        padding: 0;
        font-size: 1rem;
        font-weight: 300;
        align-items: center;
        font-family: 'Futura PT';
        text-decoration: underline;
        color: ${({ theme }) => theme.colors.tertiary_500};
        svg {
          font-size: 1.2rem;
        }
      }
    }

    .exceededContacts {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 0.5rem;

      p {
        color: ${({ theme }) => theme.colors.error_500};
        font-size: 1rem;
        font-weight: 500;
      }

      svg {
        fill: ${({ theme }) => theme.colors.error_500};
        width: 1rem;
      }
    }
  }

  .contentPresentationLetter {
    margin-top: 1rem;

    .progress {
      position: absolute;
      bottom: 0;
      right: 0;
    }
    .presentationLetter {
      display: flex;
      width: 100%;
      height: 8rem;
      border-radius: 0.7rem;
      border-color: ${({ theme }) => theme.colors.primary};
      background-color: ${({ theme }) => theme.colors.background_white};
      font-size: 1.2rem;
      font-family: 'Futura PT';
      padding: 0.5rem 0.5rem 2.5rem 0.5rem;
      color: ${({ theme }) => theme.colors.text};
      resize: none;

      :focus-visible {
        outline: none;
        border: 2px solid ${({ theme }) => theme.colors.secondary};
      }
    }
    .counterPresentationLetter {
      display: flex;
      padding: 0.5rem 1rem;
      color: ${({ theme }) => theme.colors.secondary};
    }
  }

  .containerSocial {
    .contentSocial {
      padding: 0.5rem 0;
      display: flex;
      flex-direction: column;

      .social {
        display: flex;
        gap: 0.2rem;
        align-items: baseline;
        margin-bottom: 0.5rem;

        p {
          color: ${({ theme }) => theme.colors.primary};
          font-size: 1.3rem;
          font-weight: 600;
          width: 7rem;
          text-align: end;
        }
      }
    }
  }

  @media (max-width: 750px) {
    .containerPicture .contentPicture {
      width: 100%;
    }

    .containerOrigin {
      flex-direction: column;

      .selectOrigin {
        flex-direction: column;
      }
    }
  }
`;

export const ContentSummary = styled.div`
  display: flex;
  .containerSummary {
    width: 100%;

    .containerOrigin {
      display: flex;
      gap: 1rem;

      p {
        font-size: 1.7rem;
        font-weight: 600;
        padding: 0;
        color: ${({ theme }) => theme.colors.secondary};
      }

      .selectOrigin {
        display: flex;
      }
    }

    .headerSummary {
      display: flex;
      justify-content: space-between;

      button {
        padding: 0;
      }
    }

    button {
      font-size: 1.7rem;
      font-weight: 600;
      padding: 0;
      color: ${({ theme }) => theme.colors.secondary};
      background: transparent;
      border: none;
    }

    .containerPicture {
      display: flex;
      flex-direction: column;

      img {
        margin: 1rem;
        border-radius: 100%;
        box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.25);
        max-width: 10rem;
        min-width: 10rem;
        max-height: 10rem;
        min-height: 10rem;
      }
    }

    .containerContacts {
      button {
        padding: 0;
      }

      .contentContacts {
        .contact {
          display: flex;
          padding: 1rem;
          align-items: center;
          gap: 0.5rem;

          p {
            font-size: 1.3rem;
            font-weight: 400;
            color: ${({ theme }) => theme.colors.primary};
          }

          button {
            display: flex;
            font-size: 1.2rem;
            font-weight: 400;
            padding: 0;
            color: ${({ theme }) => theme.colors.text_gray};
          }

          .contactRepeated {
            p {
              color: ${({ theme }) => theme.colors.error_500};
              font-size: 1rem;
            }

            svg {
              fill: ${({ theme }) => theme.colors.error_500};
              width: 1rem;
            }
          }
        }
      }
    }
    .summaryItens {
      .contentPresentationLetter {
        display: flex;
        position: relative;
        button {
          width: 95%;
          padding: 0;
          font-size: 1.3rem;
          font-weight: 400;
          overflow-y: auto;
          color: ${({ theme }) => theme.colors.primary};
          padding: 0.5rem 1rem;
          text-align: start;
        }
      }
    }
    .containerSocial {
      button {
        padding: 0;
      }

      .contentSocial {
        display: flex;
        flex-direction: column;
        gap: 1rem;
        padding: 1rem 0;
      }

      .social {
        display: flex;
        align-items: baseline;

        p {
          color: ${({ theme }) => theme.colors.primary};
          text-align: end;
          font-size: 1.3rem;
          font-weight: 600;
        }

        button {
          font-size: 1.3rem;
          font-weight: 600;
          color: ${({ theme }) => theme.colors.primary};
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
      }
    }

    @media (max-width: 750px) {
      .containerOrigin {
        flex-direction: column;

        .selectOrigin {
          flex-direction: column;
        }
      }
    }
  }
`;

export const PopoverContainer = styled.div`
  background: ${({ theme }) => theme.colors.background_white};
  display: flex;
  justify-items: flex-start;
  padding: 0.5rem;
  max-height: 100%;
  display: grid;
  gap: 0.5rem;

  button {
    font-size: 1.3rem;
    color: ${({ theme }) => theme.colors.secondary};
    max-height: 2rem;
    background: none;
    border: none;
    cursor: pointer;
  }
`;
